/**
 * /tenant-settings?tab=xxx の旧URLを新URLへリダイレクトするコンポーネント
 *
 * 旧: /tenant-settings (tab=employment-type|holiday-types|なし)
 * 新: /tenant/employment-type | /tenant/holiday | /tenant/basic
 */
import { Navigate, useSearchParams } from "react-router-dom";

export function TenantSettingsRedirect() {
    const [searchParams] = useSearchParams();
    const tab = searchParams.get("tab");

    if (tab === "employment-type") {
        return <Navigate to="/tenant/employment-type" replace />;
    }
    if (tab === "holiday-types") {
        return <Navigate to="/tenant/holiday" replace />;
    }
    return <Navigate to="/tenant/basic" replace />;
}
